export const ANALYTICS_S3_BUCKET_FOLDER = "ameya_analytics"
export const ANALYTICS_S3_BUCKET_SCRIPT_FILE = "analyticsConfig"
export const ANALYTICS_S3_BUCKET_CHATBOT_LOGO = "analytics_logo"